import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = '/api';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    if (localStorage.getItem('auth_expired')) {
      setError('Platnosť prihlásenia vypršala. Prihláste sa prosím znovu.');
      localStorage.removeItem('auth_expired');
    }
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      if (response.data.refreshToken) localStorage.setItem('refresh_token', response.data.refreshToken);
      window.location.href = '/home';
    } catch (err: any) {
      setError(err.response?.data?.error || 'Chyba pri prihlásení');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
      <div style={{ backgroundColor: 'white', padding: '2rem', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>

        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="/mgtech-logo.png" alt="mG.tech" style={{ maxHeight: '120px', maxWidth: '320px', objectFit: 'contain', display: 'block', margin: '0 auto 1rem' }} />
          <h1 style={{ margin: 0, color: '#1f2937', fontSize: '1.4rem' }}>Schvaľovanie faktúr</h1>
        </div>

        {error && (
          <div style={{ backgroundColor: '#fee2e2', color: '#dc2626', padding: '0.75rem', borderRadius: '4px', marginBottom: '1rem' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '1rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', color: '#374151' }}>Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' }} />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label style={{ display: 'block', marginBottom: '0.5rem', color: '#374151' }}>Heslo</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
              style={{ width: '100%', padding: '0.5rem', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '1rem', boxSizing: 'border-box' }} />
          </div>

          <button type="submit" disabled={loading}
            style={{ width: '100%', padding: '0.75rem', backgroundColor: loading ? '#9ca3af' : '#2563eb', color: 'white', border: 'none', borderRadius: '4px', fontSize: '1rem', cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Prihlasovanie...' : 'Prihlásiť sa'}
          </button>
        </form>

        <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', margin: '1.25rem 0 1rem', color: '#9ca3af', fontSize: '0.8rem' }}>
          <div style={{ flex: 1, height: 1, backgroundColor: '#e5e7eb' }} />
          <span>Nemáte účet?</span>
          <div style={{ flex: 1, height: 1, backgroundColor: '#e5e7eb' }} />
        </div>
        <a href="/register" style={{
          display: 'block', width: '100%', padding: '0.7rem', textAlign: 'center',
          backgroundColor: 'white', color: '#2563eb', border: '1.5px solid #2563eb',
          borderRadius: '4px', fontSize: '1rem', fontWeight: 600, textDecoration: 'none',
          boxSizing: 'border-box',
        }}>
          Zaregistrujte sa zadarmo →
        </a>
      </div>
    </div>
  );
}
